const HttpStatusCodes = {
  Unauthorized: 401,
  BadRequest: 400,
  NetworkError: "Network Error",
};

export default HttpStatusCodes;
